import ComposeSMSComponent from './compose';
import CustomInput from '../reusable/input';
import { formatDateWithTime } from '../../helper';
import ImageClass from '../../assets';
import SelectedSMSComponent from './sms_thread';
import { SMSObject } from '../../params/redux/sms';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, InputAdornment, Typography } from '@mui/material';
import { ChatBubbleOutlineOutlined, DraftsOutlined, RepeatRounded, Search } from '@mui/icons-material';
import { settingComposingFlagSMS, settingSelectedSMS } from '../../redux/slices/sms';
import { useDispatch, useSelector } from 'react-redux';

const SMSDetailComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [search, setSearch] = useState<string>('');
    const { integrations } = useSelector((state: RootState) => state.integration);
    const { flags, sms, selectedSms, loaders } = useSelector((state: RootState) => state.sms);
    const doesIntegratedOrNot = integrations.includes('twilio') || flags.isIntegrated;

    const filteredSMS = sms.filter((e: SMSObject) => {
        const message = e.message.toLowerCase();
        const to = e.message_to.toLowerCase();
        return (
            !search ||
            message.includes(search.toLowerCase()) ||
            to.includes(search.toLowerCase())
        );
    });

    const composeHandler = () => {
        dispatch(settingComposingFlagSMS(true));
    };

    const selectedSMSHandler = (message: SMSObject) => {
        dispatch(settingSelectedSMS(message));
    };

    if (flags.composing && doesIntegratedOrNot) {
        return <ComposeSMSComponent />;
    } else if (selectedSms && doesIntegratedOrNot) {
        return <SelectedSMSComponent />;
    }

    return (<Box minHeight="60vh">
        <Box display="flex" justifyContent="space-between" alignItems="center">
            <CustomInput
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                disabled={loaders.isLoading}
                slotProps={{
                    input: {
                        startAdornment: <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    }
                }}
                placeholder="Search..."
            />
            <Box display="flex" gap={2}>
                {<Box display="none"><IconButton color="primary" disabled={loaders.isLoading}>
                    <RepeatRounded />
                </IconButton>
                    <Button variant="text" disabled={loaders.isLoading} startIcon={<DraftsOutlined />} >Mark all as read</Button></Box>}
                <Button variant="contained" disabled={loaders.isLoading} startIcon={<ChatBubbleOutlineOutlined />} onClick={composeHandler}>Send SMS</Button>
            </Box>
        </Box>

        <Box display="flex" flexDirection="column" gap={1} my={2}>
            {
                filteredSMS.length === 0 && sms.length === 0
                    ? <Box height="100%" display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems="center">
                        <img src={ImageClass.noPhoneConversation} alt="Email Placeholder" height="300px" />
                        <Typography variant="subtitle1" color="textSecondary" align="center">No conversations yet. Send an SMS to start chatting</Typography>
                    </Box>
                    : filteredSMS.map((message) => <Box key={message.id} display="flex" justifyContent="space-between" alignItems="center" border="1px solid #ddd" sx={{
                        cursor: 'pointer'
                    }} borderRadius={1} p={2} onClick={() => selectedSMSHandler(message)}>
                        <Typography variant="body1" color="textSecondary" fontWeight="bold">{message.message_to}  <Typography component="span" fontWeight="500" color="textDisabled">{message.message}</Typography></Typography>
                        <Typography variant="body2" color="textDisabled">{formatDateWithTime(message.created_at)}</Typography>
                    </Box>)
            }
        </Box>
    </Box>);
};

export default SMSDetailComponent;